export const HOME_ROUTE = "/";
export const ABOUT_ROUTE = "/about";
export const ADMISSION_ROUTE = "/admission";
export const FACILITY_ROUTE = "/facility";
export const CONTACT_ROUTE = "/contact";
export const CALENDAR_ROUTE = "/calendar";
export const TRANSPORT_ROUTES = "/transport-routes";
export const PRIVACY_ROUTE = "/privacy";
export const TERMS_ROUTE = "/terms";
